import KvSelect from './KvSelect.vue';
import UserName from './UserName';
// import StorageObjectDisplay from './StorageDisplay.vue';
import _Vue, { PluginObject } from 'vue';
import Text from './Typography/Text';
// import DeptPath from './DeptPath.vue';
import Space from './Space.vue';

// import SchoolSelectId from './SchoolSelectId.vue';
// import ExportFile from './ExportFile.vue';
// export type PluginFunction<T> = (Vue: typeof _Vue, options?: T) => void;
export function Ch2ComponsePlugin<AxiosPlugOptions>(Vue: typeof _Vue, options?: Ch2ComponsePluginOptions): void {
  Vue.component('c-username', UserName);
  Vue.component('c-text', Text);
  Vue.component('c-space', Space);
}

export class Ch2ComponsePluginOptions {
  // add stuff
}
